<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Rhvc7H/media/FC-9781398446885.jpg?1685790543959" alt="This image is the cover for the book Enter Spice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enter Spice
      </h1>
      <p class="bookDescription body article font2">
        <p>Enter Spice is a sequel to Enter Donegal. Spice, a charming Cocker Spaniel arrives at the Ellis home after Donegal has gone, and obviously at his request. She is readily accepted and loved by all family members. <br/>With the gifts of walking upright, speaking, reading, writing and singing, she helps Scott and Lara in their ‘love’ relationships, frustrates the attempt of a work colleague of Beth’s to prevent her promotion, and rescues children lost in mountainous bushland. <br/>Her hilarious ‘coming out’, or revealing her talents, causes a sensation on ‘Australia’s Got Talent’ and results in her kidnapping from which she manages to escape in a surprising and unusual manner. <br/>Her own brush with near-death leads her to devote herself to helping the seriously ill in hospitals. <br/>Like Donegal, she makes a very different announcement that has implications for the whole Ellis family. <br/>This heart-warming novel underlines the significance of animals (dogs in particular), demonstrates the value of all living things, indicates ways in which we can help one another, and asserts the triumph of goodness over evil.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Brady
      </h2>
      
      <p class="authorDescription body article">Laurie Brady is a published poet, a writer of short stories, a novelist, and a great dog lover who lives in Sydney, Australia. He has a keen sense of humour, particularly a liking for the ridiculous, and a love of literature and sport. He has spent most of his working life as a teacher and a teacher educator, promoting engaging and quality schooling. He retired recently as professor of education at the University of Technology, Sydney.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66f06f08